<template>
  <div class="nx-searcher-filter-text-input pr-4">
    <v-text-field
      @input="updateFilters"
      :value="value"
      :label="$t(`message.searcher.filters.content.${filter}`)"
      :disabled="disabled"
    >
    </v-text-field>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Filter from './Filter';

export default {
  name: 'nx-searcher-filter-text-input',
  extends: Filter,
  methods: {
    // eslint-disable-next-line
    updateFilters: debounce(function (value) {
      this.$emit('input', this.filter, value.trim() || null);
    }, 600),
  },
};
</script>
